/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { getFormatValues } from '../../../../lib/utils';

import organisations from '../../../../../img/guest/organisations';
import team from '../../../../../img/guest/team';

import styles from '../../../../../styles/guest/sections/content/organisations.module.scss';

const propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    active: false,
    className: null,
};

const Organisations = ({ active, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.active]: active,
            },
        ])}
    >
        <div className={styles.title}>
            <div className={styles.titleInner}>
                <h2>
                    <FormattedMessage
                        defaultMessage="An open and welcoming ecosystem"
                        description="Guest content - organisations title"
                        values={getFormatValues()}
                    />
                </h2>
            </div>
        </div>
        <div className={styles.description}>
            <div className={styles.descriptionInner}>
                <div className={styles.organisations}>
                    <div className={styles.logos}>
                        {organisations.map((organisation, organisationIndex) => (
                            <div
                                key={`organisation-${organisationIndex}`}
                                className={styles.organisation}
                                style={{ backgroundImage: `url(${organisation})` }}
                            />
                        ))}
                    </div>
                    <p>
                        <FormattedMessage
                            defaultMessage="By creating multiple organizations and associating them with your account, you can coordinate posts for all your brands from the same{nbsp}place."
                            description="Guest content - organisations content"
                            values={getFormatValues()}
                        />
                    </p>
                </div>
                <div className={styles.team}>
                    <div className={styles.logos}>
                        {team.map((teamMember, teamMemberIndex) => (
                            <div
                                key={`team-member-${teamMemberIndex}`}
                                className={styles.teamMember}
                                style={{ backgroundImage: `url(${teamMember})` }}
                            />
                        ))}
                    </div>
                    <p>
                        <FormattedMessage
                            defaultMessage="Next, build your teams by inviting new users so you can simultaneously contribute to the content for a given{nbsp}project."
                            description="Guest content - organisations team"
                            values={getFormatValues()}
                        />
                    </p>
                    <p>
                        <FormattedMessage
                            defaultMessage="The platform provides stats for your posts and can even connect your Google Analytics account if you'd{nbsp}like."
                            description="Guest content - organisations analytics"
                            values={getFormatValues()}
                        />
                    </p>
                </div>
            </div>
        </div>
    </div>
);

Organisations.propTypes = propTypes;
Organisations.defaultProps = defaultProps;

export default Organisations;
